import type { ThemeComponents } from '@chakra-ui/react';
import type {
  ComponentMultiStyleConfig,
  ComponentStyleConfig,
} from '@chakra-ui/theme';

import {
  badgeStyles,
  dataListStyles,
  dataTableStyles,
  tableStyles,
  tagStyles,
} from './DataVis';
import {
  ButtonStyles,
  CheckboxStyles,
  FileUploadBoxStyles,
  FormControlStyles,
  FormErrorStyles,
  FormLabelStyles,
  InputStyles,
  NumberInputStyles,
  RadioStyles,
  RangeSliderStyles,
  SelectStyles,
  SwitchStyles,
  TextareaStyles,
  closeButtonStyles,
} from './Forms';
import { HeadingStyles } from './Heading.style';
import {
  DividerStyles,
  TabStyles,
  accordionStyles,
  pageHeaderStyles,
} from './Layout';
import {
  SidebarItemStyles,
  SidebarStyles,
  breadcrumbStyles,
} from './Navigation';
import {
  AlertStyles,
  DrawerStyles,
  MenuStyles,
  ModalStyles,
  TooltipStyles,
} from './Overlay';
import { cardPageStyles, splitPageStyles } from './Pages';
import { PopoverStyles } from './Popover.style';
import { ProgressStyles, SpinnerStyles } from './Progress';

// Accept both single- and multi-style component configs (often authored as Partial)
type AnyComp =
  | Partial<ComponentStyleConfig>
  | Partial<ComponentMultiStyleConfig>;

// Build with a permissive internal map first
const componentsMap: Record<string, AnyComp> = {
  Accordion: accordionStyles,
  Alert: AlertStyles,
  Breadcrumb: breadcrumbStyles,
  Badge: badgeStyles,
  Button: ButtonStyles,
  CardPage: cardPageStyles,
  SplitPage: splitPageStyles,
  Checkbox: CheckboxStyles,
  DataTable: dataTableStyles,
  DataList: dataListStyles,
  Divider: DividerStyles,
  Drawer: DrawerStyles,
  Form: FormControlStyles,
  FormError: FormErrorStyles,
  FormLabel: FormLabelStyles,
  Heading: HeadingStyles,
  Input: InputStyles,
  Menu: MenuStyles,
  Modal: ModalStyles,
  NumberInput: NumberInputStyles,
  Popover: PopoverStyles,
  Progress: ProgressStyles,
  Radio: RadioStyles,
  Slider: RangeSliderStyles,
  Select: SelectStyles,
  Sidebar: SidebarStyles,
  SidebarItem: SidebarItemStyles,
  Spinner: SpinnerStyles,
  Switch: SwitchStyles,
  Tabs: TabStyles,
  Table: tableStyles,
  Tag: tagStyles,
  Textarea: TextareaStyles,
  Tooltip: TooltipStyles,
  CloseButton: closeButtonStyles,
  PageHeader: pageHeaderStyles,
  FileUploadBox: FileUploadBoxStyles,
};

// Export with the Chakra ThemeComponents type expected by extendTheme()
export const components = componentsMap as unknown as ThemeComponents;
